import axios from 'axios'

export const state = {
  volunteers: null,
}

export const getters = {
  volunteers: (state) => state.volunteers,

  volunteerOptions: (state) =>
    (state.volunteers || []).map(({ id, first_name, last_name }) => ({
      id: id,
      label: [first_name, last_name].join(' '),
    })),
}

export const mutations = {
  SET_VOLUNTEERS(state, volunteers) {
    state.volunteers = volunteers
  },
}

export const actions = {
  fetchAllVolunteers({ commit, state, rootState }, payload) {
    return axios
      .get('/api/users', {
        params: {
          ...payload,
          role: 'volunteer',
          active: 'true',
          compact: 'true',
        },
      })
      .then((response) => {
        const volunteers = response.data
        commit('SET_VOLUNTEERS', volunteers)
        return volunteers
      })
  },

  createVolunteer({ commit, state, rootState }, payload) {
    return axios.post(`/api/kids/${payload.kid_id}/volunteers`, payload)
  },

  updateVolunteer({ commit, state, rootState }, payload) {
    return axios.put(
      `/api/kids/${payload.kid_id}/volunteers/${payload.id}`,
      payload,
    )
  },

  deleteVolunteer({ commit, state, rootState }, payload) {
    return axios.delete(`/api/kids/${payload.kid_id}/volunteers/${payload.id}`)
  },
}
